import { type Brand, make } from 'ts-brand';

import { type State } from './state';

/** Shape of the {@link Address} model. */
export type AddressShape = Readonly<{

  /** City. */
  city: string;

  /** Country state. */
  state: State | null;

  /** First address line. */
  addressLine1: string;

  /** Second address line. */
  addressLine2: string;

  /** Country. */
  country: string;
}>;

/** Address model. */
export type Address = Brand<AddressShape, 'Address'>;

/** Address model constructor. */
export const makeAddress = make<Address>();
